import React from 'react';
import { FileIconBase } from './_base';
const SheetFileIcon = (props) => (React.createElement(FileIconBase, Object.assign({}, props, { defaultColor: "#1F8B4C", label: "XLS" })));
export default SheetFileIcon;
